/**
 * 全域使用的共用函示
 */

/**
 * 取得網址語系參數
 */
export function getUrlLang() {
  const urlParams = new URLSearchParams(location.search)
  let auth = null, lang = null
  if (urlParams.has('lang')) {
    lang = urlParams.get('lang')
  }
  if (urlParams.has('auth')) {
    auth = decodeAuth(urlParams.get('auth'))
    const { a } = auth
    lang = a?.l
  }

  const langList = ['zh_cn', 'en_us', 'th_th', 'vi_vn', 'id_id', 'zh_hk', 'ko_kr', 'ja_jp', 'pt_pt', 'es_es', 'bn_bd', 'hi_in', 'fr_fr']
  switch (true) {
    case (langList.includes(lang)):
      return lang
    default:
      return 'en_us'
  }
}

export function decodeAuth(str) {
  const strings = str.split('.') //截取token，获取载体
  if (strings.length < 2) return {}
  const s = strings[1].replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '')
  let auth = {}
  try {
    // 需要測試的語句
    auth = JSON.parse(decodeURIComponent(escape(window.atob(s)))) //解析，需要吧‘_’,'-'进行转换否则会无法解析
  } catch (e) {
    console.log(e) // 把例外物件傳給錯誤處理器
  }
  return auth
}

